import { useTranslation } from "react-i18next";

interface TitleProps {
  title: string;
  subtitle?: string;
  thirdTitle?: string;
}

const Title = ({ title, subtitle, thirdTitle }: TitleProps) => {
  const { i18n, t } = useTranslation();
  return (
    <section className="my-[50px] w-full h-[290px] px-[20px] bg-aboutbg bg-cover flex flex-col items-center justify-center ">
      <p className="text-[24px] lg:text-[40px] font-[700] text-center">
        {title}
      </p>
      <p className="lg:text-[14px] text-[#707070] text-center">
        {t("Home")} {`>`} {subtitle} {thirdTitle && `> ${thirdTitle}`}
      </p>
    </section>
  );
};

export default Title;
